import React from "react";
import PropTypes from "prop-types";
import LoadingSVG from "../../helpers/LoadingSVG";

const DashboardWrapperCard= (props) => (		  
	<div className="dashboard-wrapper-card">
		{props.isLoading ? <LoadingSVG /> : <React.Fragment>{props.children}</React.Fragment> }
	</div>
);

DashboardWrapperCard.defaultProps = {
	isLoading: false,
};

DashboardWrapperCard.propTypes = {
	isLoading: PropTypes.bool,
	children: PropTypes.node.isRequired
};

export default DashboardWrapperCard;



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/DashboardWrapperCard.js